import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function TextQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <g id='Layer 2'>
        <g id='text'>
          <path
            id='Vector'
            d='M13.3333 2.66667H2.66667C2.48986 2.66667 2.32029 2.73691 2.19526 2.86193C2.07024 2.98696 2 3.15653 2 3.33334V5.33334C2 5.51015 2.07024 5.67972 2.19526 5.80474C2.32029 5.92977 2.48986 6 2.66667 6C2.84348 6 3.01305 5.92977 3.13807 5.80474C3.2631 5.67972 3.33333 5.51015 3.33333 5.33334V4.00001H7.33333V12.6667H6C5.82319 12.6667 5.65362 12.7369 5.5286 12.8619C5.40357 12.987 5.33333 13.1565 5.33333 13.3333C5.33333 13.5101 5.40357 13.6797 5.5286 13.8047C5.65362 13.9298 5.82319 14 6 14H10C10.1768 14 10.3464 13.9298 10.4714 13.8047C10.5964 13.6797 10.6667 13.5101 10.6667 13.3333C10.6667 13.1565 10.5964 12.987 10.4714 12.8619C10.3464 12.7369 10.1768 12.6667 10 12.6667H8.66667V4.00001H12.6667V5.33334C12.6667 5.51015 12.7369 5.67972 12.8619 5.80474C12.987 5.92977 13.1565 6 13.3333 6C13.5101 6 13.6797 5.92977 13.8047 5.80474C13.9298 5.67972 14 5.51015 14 5.33334V3.33334C14 3.15653 13.9298 2.98696 13.8047 2.86193C13.6797 2.73691 13.5101 2.66667 13.3333 2.66667Z'
          />
        </g>
      </g>
    </SvgIcon>
  );
}
